__turbopack_context__.v({
  "fullBodySection": "ProfilePhotos-module-scss-module__8AUjxq__fullBodySection",
  "headshotSection": "ProfilePhotos-module-scss-module__8AUjxq__headshotSection",
  "profilePhotosContainer": "ProfilePhotos-module-scss-module__8AUjxq__profilePhotosContainer",
});
